import { useTracking } from 'react-tracking';
import loadable from '@loadable/component';

import { Heading, Grid } from '@simplywallst/ui-core';

import { PortfolioDropdown } from '../../components/PortfolioDropdown';
import DocumentHeader from '@/components/DocumentHeader';
import { OneColumn } from '@/components/Layout';
import { ManualPortfolioProvider } from '../../components/PortfolioManual';

import { usePortfolios } from '@/hooks/portfolio/usePortfolio';

/**
 * @deprecated
 */
const CreatePortfolio = loadable(() => import('./components/CreatePortfolio'), {
  resolveComponent: (c) => c.CreatePortfolio,
});

/**
 * @deprecated Move to 'NewPortfolioPage'
 */
export const DeprecatedNewPortfolio = () => {
  const { data: portfolios } = usePortfolios();
  const { trackEvent } = useTracking();

  return (
    <ManualPortfolioProvider>
      <OneColumn>
        <DocumentHeader title="Portfolio" />
        <Grid
          as="header"
          templateRows="40px"
          alignItems="center"
          padding="x2"
          paddingXLg="x0"
        >
          {portfolios?.length ? (
            <PortfolioDropdown
              portfolioId={null}
              onClick={() => {
                trackEvent({
                  modifier: 'myPortfolioDropDown',
                  // Force subject to be page
                  subject: 'page',
                  action: 'click',
                });
              }}
            >
              <Heading as="h1" typography="megaStrong">
                My Portfolio
              </Heading>
            </PortfolioDropdown>
          ) : (
            <Heading as="h1" typography="megaStrong">
              My Portfolio
            </Heading>
          )}
        </Grid>
        <CreatePortfolio />
      </OneColumn>
    </ManualPortfolioProvider>
  );
};
